import { useEffect, useState } from "react";

import { getWinnersData } from "@/app/(general-header)/botb-pass/subscription-service";
import { SimplifiedWinner } from "@/app/(general-header)/winners/types";

const MONTH_MAP: Record<string, string> = {
  Jan: "January",
  Feb: "February",
  Mar: "March",
  Apr: "April",
  May: "May",
  Jun: "June",
  Jul: "July",
  Aug: "August",
  Sep: "September",
  Oct: "October",
  Nov: "November",
  Dec: "December",
};

let cachedWinners: SimplifiedWinner[] | null = null;
let winnersPromise: Promise<SimplifiedWinner[]> | null = null;

function fetchPassWinners(): Promise<SimplifiedWinner[]> {
  if (!winnersPromise) {
    winnersPromise = getWinnersData()
      .then(res => res.json() as Promise<SimplifiedWinner[]>)
      .then(res => {
        cachedWinners = res;
        return res;
      })
      .catch(err => {
        winnersPromise = null;
        console.error("Error fetching pass winners:", err);
        throw err;
      });
  }
  return winnersPromise;
}

export function prefetchPassWinners() {
  void fetchPassWinners().catch(() => undefined);
}

export function formatMonthYear(shortDate: string): string {
  const [month, year] = shortDate.split(" ");
  const fullMonth = MONTH_MAP[month];

  if (!fullMonth || !year) {
    throw new Error("Invalid date format. Expected format: 'MMM YYYY'");
  }
  return `${fullMonth} ${year}`;
}

export function usePassWinners() {
  const [winners, setWinners] = useState<SimplifiedWinner[]>(() => cachedWinners ?? []);
  const [loading, setLoading] = useState(() => cachedWinners === null);

  useEffect(() => {
    if (cachedWinners) {
      setWinners(cachedWinners);
      setLoading(false);
      return;
    }

    let cancelled = false;
    fetchPassWinners()
      .then(res => {
        if (!cancelled) setWinners(res);
      })
      .catch(() => undefined)
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { winners, loading };
}
